import React from "react";
import ReactModal from "react-modal";

import { Icon } from "../../../components/ui";
import { useInlineSurface } from "./inlineSurface";
import "./inline-or-modal.scss";


/**
 * A drop-in for <ReactModal>. Outside an inline surface it IS a ReactModal with
 * exactly the props it was given — product pages, the DAO setup and every other
 * caller render as before. Inside one (the quote workspace) the same content
 * opens in place, as a panel right where the modal was declared, with a close
 * button (unless the content brings its own: `inlineClose={false}`).
 * `inlineRow`: the modal is declared among table rows, so in place it becomes a
 * full-width row rather than a <div> the table cannot hold.
 */
export default function InlineOrModal({
  isOpen,
  onRequestClose,
  children,
  contentLabel,
  inlineClose = true,
  inlineRow = false,
  ...modalProps
}) {
  const inline = useInlineSurface();

  if (!inline) {
    return (
      <ReactModal isOpen={isOpen} onRequestClose={onRequestClose} contentLabel={contentLabel} {...modalProps}>
        {children}
      </ReactModal>
    );
  }

  if (!isOpen) return null;

  const panel = (
    <div className="inline-surface" role="group" aria-label={contentLabel || undefined}>
      {inlineClose && onRequestClose && (
        <button type="button" className="inline-surface__close" aria-label="Close" onClick={onRequestClose}>
          <Icon name="X" size="sm" />
        </button>
      )}
      {children}
    </div>
  );

  return inlineRow ? (
    <tr className="inline-surface-row">
      <td colSpan={100}>{panel}</td>
    </tr>
  ) : (
    panel
  );
}
